import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import OTP from './pages/OTP';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import RegisterForm from "./pages/RegisterForm";
import LeadDetails from './components/LeadDetails/LeadDetails';
import RawLeadDetails from './components/LeadDetails/RawLeadDetails';
import LeadTable from './components/leadTable/LeadTable';
import PrivateRoute from './utils/PrivateRoute';
import CityWiseLead from './components/admin/MainCityWiseLeadPage';
import MainMemberDirectoryPage from './components/admin/memberDirecotry/MainMemberDirectoryPage';

// Component to handle root route redirection
const RootRedirect: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem("auth") || 
                          !!localStorage.getItem("authToken") || 
                          !!localStorage.getItem("gp_token");
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/" replace />;
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/otp" element={<OTP />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register/form" element={<RegisterForm />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/lead/:id"
          element={
            <PrivateRoute>
              <LeadDetails />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/leads"
          element={
            <PrivateRoute>
              <LeadTable />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/rawlead/:id"
          element={
            <PrivateRoute>
              <RawLeadDetails />
            </PrivateRoute>
          }
        />
          <Route
          path="/admin"
          element={
            <PrivateRoute>
              <CityWiseLead />
            </PrivateRoute>
          }
        />
                  <Route
          path="/member-directory"
          element={
            <PrivateRoute>
              <MainMemberDirectoryPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;